import api from '.';
import { ProjectWithManHour } from '../pages/Dashboard/dashboardSlice';

interface QueryOverviewProject {
  businessUnitNames: string[];
  startDate: Date;
  endDate: Date;
  page: number;
  limit: number;
  status: string;
  search: string | null;
  today: Date;
}

interface ReturnQueryOverviewProjectType {
  count: number;
  data: ProjectWithManHour[];
}

export async function getOverviewProjects(
  params: QueryOverviewProject
): Promise<ReturnQueryOverviewProjectType> {
  const { data } = await api.get('/dashboards/projects', {
    params
  });
  return data;
}
